import React from 'react';
import RemoveTimesheetDetailButton from './RemoveTimesheetDetailButton';
import TimesheetDetailPhaseSelect from './TimesheetDetailPhaseSelect';
import { Input } from 'reactstrap';
import { calculateTimesheetDetailElapsedHours } from './DailyTimesheet';

export default class DailyTimesheetDetail extends React.Component {
    onStartTimeChange = (e) => {
        const {
            dailyTimesheetDetail,
            dailyTimesheet,
            onDailyTimesheetMutated,
        } = this.props;

        dailyTimesheetDetail.startTime = e.target.value;

        dailyTimesheetDetail.hoursSpent = calculateTimesheetDetailElapsedHours(
            dailyTimesheet,
            dailyTimesheetDetail
        );

        onDailyTimesheetMutated(dailyTimesheet);
    };

    onEndTimeChange = (e) => {
        const {
            dailyTimesheetDetail,
            dailyTimesheet,
            onDailyTimesheetMutated,
        } = this.props;

        dailyTimesheetDetail.endTime = e.target.value;

        dailyTimesheetDetail.hoursSpent = calculateTimesheetDetailElapsedHours(
            dailyTimesheet,
            dailyTimesheetDetail
        );

        onDailyTimesheetMutated(dailyTimesheet);
    };

    render() {
        const { dailyTimesheet, dailyTimesheetDetail, contracts, readOnly } =
            this.props;

        const contract = contracts.find(
            (c) => c.id == dailyTimesheetDetail.contractId
        );

        return (
            <tr>
                <td className="align-middle">
                    {contract.companyName} - {contract.number}
                </td>
                <td className="align-middle">
                    <TimesheetDetailPhaseSelect
                        {...this.props}
                        contract={contract}
                    />
                </td>
                <td className="align-middle">
                    <Input
                        type="time"
                        value={dailyTimesheetDetail.startTime}
                        onChange={this.onStartTimeChange}
                        readOnly={readOnly}
                    />
                </td>
                <td className="align-middle">
                    <Input
                        type="time"
                        value={dailyTimesheetDetail.endTime}
                        onChange={this.onEndTimeChange}
                        readOnly={readOnly}
                    />
                </td>
                <td className="align-middle">
                    {calculateTimesheetDetailElapsedHours(
                        dailyTimesheet,
                        dailyTimesheetDetail
                    )}
                </td>
                <td className="align-middle">
                    <RemoveTimesheetDetailButton {...this.props} />
                </td>
            </tr>
        );
    }
}
